import { useState } from 'react'

import { Box } from '@chakra-ui/react'

import { DEFAULT_CHAR_LIMIT } from '../utils/utils'
import { ShowMoreButton } from './ShowMoreButton'

interface ShowMoreIProps {
  message: string
  characterLimit?: number
  handleShowMore?: () => void
  handleShowLess?: () => void
}

export const ShowMore = ({
  message,
  characterLimit = DEFAULT_CHAR_LIMIT,
  handleShowMore,
  handleShowLess,
}: ShowMoreIProps) => {
  const [isExpanded, setExpanded] = useState(false)

  const handleToggle = () => {
    isExpanded ? handleShowLess?.() : handleShowMore?.()
    setExpanded((prev) => !prev)
  }

  if (message.length < characterLimit) {
    return (
      <Box as='span' whiteSpace='pre-line'>
        {message}
      </Box>
    )
  }

  return (
    <>
      <Box as='span' whiteSpace='pre-line'>
        {isExpanded ? message : message.substring(0, characterLimit) + '...'}
      </Box>
      <ShowMoreButton isExpanded={isExpanded} onClick={handleToggle} />
    </>
  )
}
